import React, { FC } from 'react'

import { Txt, Icon, ShadedButton } from 'src/components/atoms'
import { AddInternalUserTooltip, AddExternalUserTooltip } from 'src/components/molecules'

type Props = {
  type: 'internal' | 'external'
  onClick?: () => void
  className?: string
}

export const AddUserButton: FC<Props> = ({ type, onClick, className }) => {
  const Tooltip = type === 'internal' ? AddInternalUserTooltip : AddExternalUserTooltip

  return (
    <ShadedButton className={className} onClick={onClick}>
      <Tooltip>
        <div className="tw-flex tw-items-center">
          <Icon size="--r1" path="user-plus/soft/line" />
          <Txt sizeType="s" className="tw-font-bold tw-ml-s-3">
            ユーザー追加
          </Txt>
        </div>
      </Tooltip>
    </ShadedButton>
  )
}
